<template>
  <m-dialog
      page
      @close="$router.push({name: 'order'})"
      name="demo"
      title="Select Demographic">
    <div  slot="menu" class="m-scroll-v">
      <b-link v-for = "item in demoTabs"
              @click='go(item)'
              class="m-scroll-v-tab"
              :id="'demo-tab-' + item.demoType"
              :class="{'m-scroll-v-tab-active': item.demoType === demoOption}"
              :key = "item.name" >
        {{item.title}}
      </b-link>
    </div>

    <m-box >
      <slot></slot>
    </m-box>

    <b-btn style="margin-left: 8px" variant="primary" @click="$router.push({name: 'order'})">Done</b-btn>



  </m-dialog>
</template>

<script>
  export default {
    components: {
    },
    props: {
      demoOption: {
        type: String,
        default: 'demo'  // 'normal', 'quickPick', 'suppression', 'search', 'demo', 'interests', 'audience'
      }
    },
    data () {
      return {}
    },
    computed: {
      datasource () {
        return this.$store.getters['config/datasource']
      },
      demoTabs () {
        return this.$store.getters['config/datasource'].demoTabs
      }
    },
    created () {
    },
    activated () {
      setTimeout(() => {
        this.$scrollTo('#demo-tab-' + this.demoOption, 1,
          {x: true, y: false, container: '.m-scroll-v', duration: 1})
      }, 100)
    },
    mounted () {
      setTimeout(() => {
        this.$scrollTo('#demo-tab-' + this.demoOption, 1,
          {x: true, y: false, container: '.m-scroll-v', duration: 1})
      }, 100)
    },
    methods: {
      go (item) {
        this.$router.push({name: 'demo-' + item.demoType})
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/demo/M2DemoBox.vue